import React, { useEffect, useRef, useState } from 'react';
import { draggable, dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import Celda from './Celda';

const FilaFranja = ({ franja, pistas, partidosPorCelda, conflictosPorCelda, editable, onDropPartido, onMoverFranja, jugadorResaltado }) => {
  const handleRef = useRef(null);
  const filaRef = useRef(null);
  const [arrastrandoFila, setArrastrandoFila] = useState(false);
  const [filaSobrevolada, setFilaSobrevolada] = useState(false);

  useEffect(() => {
    if (!editable) return;
    return combine(
      draggable({
        element: handleRef.current,
        getInitialData: () => ({ type: 'franja', franjaId: franja.id }),
        onDragStart: () => setArrastrandoFila(true),
        onDrop: () => setArrastrandoFila(false),
      }),
      dropTargetForElements({
        element: filaRef.current,
        canDrop: ({ source }) => source.data.type === 'franja' && source.data.franjaId !== franja.id,
        getData: () => ({ type: 'franja', franjaId: franja.id }),
        onDragEnter: () => setFilaSobrevolada(true),
        onDragLeave: () => setFilaSobrevolada(false),
        onDrop: ({ source }) => {
          setFilaSobrevolada(false);
          onMoverFranja(source.data.franjaId, franja.id);
        },
      }),
    );
  }, [editable, franja.id, onMoverFranja]);

  const clasesFila = ['fila-franja'];
  if (arrastrandoFila) clasesFila.push('arrastrando');
  if (filaSobrevolada) clasesFila.push('fila-sobrevolada');

  return (
    <tr ref={filaRef} className={clasesFila.join(' ')}>
      <th scope="row" className="fila-franja-hora">
        {editable && (
          <span ref={handleRef} className="fila-franja-handle" title="Arrastrar toda la franja a otra hora">⠿</span>
        )}
        {franja.hora}
      </th>
      {pistas.map((pista) => {
        const key = `${pista}-${franja.id}`;
        return (
          <Celda
            key={key}
            pista={pista}
            franjaId={franja.id}
            disponible={franja.pistasDisponibles.includes(pista)}
            partido={partidosPorCelda[key]}
            editable={editable}
            conflicto={conflictosPorCelda[key]}
            resaltado={!!jugadorResaltado && !!partidosPorCelda[key]?.jugadores.includes(jugadorResaltado)}
            onDropPartido={onDropPartido}
          />
        );
      })}
    </tr>
  );
};

export default FilaFranja;
